// MainPage.jsx
import React, { useState, useEffect } from 'react';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';



import {update_rockfall, create_rockfall, delete_rockfall} from "../api/api";
import {getColumnDefs_rockfall, newRowTemplate_rockfall, eyeIconCallback_rockfall} from "../tables_config/tables_config.js"

import TopBar from '../components/TopBar';
import Map from '../components/Map';
import {get_rockfalls} from '../api/api.js';
import { useLocation } from "react-router-dom";

const MainPage = () => {
  const [items, setItems] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [isMapClickable, setMapClickable] = useState(false);
  const [settingCoords, setSettingCoords] = useState(false);
  const [selectedCoords, setSelectedCoords] = useState(null);
  const location = useLocation();



  useEffect(() => {
      const get_the_rockfalls = async () => {
          const res = await get_rockfalls();
          const data = res && res.data && res.data.results ? res.data.results : [];
          // HERE: this works just fine
          console.log(data);
          setItems(data);     // Set state with resolved data
      };

      get_the_rockfalls();
  }, [location]);


  const openMapForCoords = (coords) => {
    setShowMap(true);
    setSettingCoords(true);
    setSelectedCoords(coords)
    window.dispatchEvent(new Event("resize"));
    setTimeout(function(){
      document.querySelectorAll(".save-edit-button").forEach((e)=>{e.disabled = true});
    }, 150);
  }

  const coordsCallback = (coords) => {
    setSelectedCoords(coords);
  }

  const closeMapForCoords = () => {
    setShowMap(false);
    setSettingCoords(false);
    window.dispatchEvent(new Event("resize"));
    setTimeout(function(){
      document.querySelectorAll(".save-edit-button").forEach((e)=>{e.disabled = false});
    }, 150);
  }


  const doShowMap = () => {
    setShowMap(true);
    window.dispatchEvent(new Event("resize"));
  }

  const doHideMap = () => {
    setShowMap(false);
    setSettingCoords(false);
  }

  const setMapClickability = (soWhat)=>{
     setMapClickable(soWhat);
  }



  const onRowSelect = (data) => {
    //doesn't ork, i dunno why and i have no time to undestrand
    //so...
    return;

    // HERE: why items is an empty array??
    var newItems = [...items];
    newItems.forEach((e)=>{
      if(e.id == data.id){
        e.selected = true;
      }
      else{
        e.selected = false;
      }
    });

    setItems(newItems);
  }

  const start_creating = () => {
    document.querySelector(".no-items").style.display = "none";
    document.querySelector(".dynamic-table-outer").style.display = "flex";
  }


  return (
    <div>
      <TopBar  />

      <div className="content">


        <h2>Lista Barriere </h2>

        <div className="main-content">
              {/*<NoItemsFound start_creating={start_creating} visible={items.length === 0 ? "block" : "none"} />*/}

              <div className="dynamic-table-outer" style={{ display: (items.length === 0 ? "none" : "flex")}}>
                <div id="the_map_container" style={{display: showMap ? "flex" : "none"}}>
                  <Map items={items} settingCoords={settingCoords} coordsCallback={coordsCallback} defaultSelectedCoords={selectedCoords} isMapClickable={isMapClickable}/>
                </div>
                {/*<DynamicTable key={items.length} items={items} callbackShowMap={doShowMap} callbackHideMap={doHideMap}/>*/}


                <DynamicTable
                  items={items}
                  labelAddNew="barriera"
                  hasMap={true}
                  callbackShowMap={doShowMap}
                  callbackHideMap={doHideMap}
                  callbackMapClickability={setMapClickability}
                  createFunction={create_rockfall}
                  updateFunction={update_rockfall}
                  deleteFunction={delete_rockfall}
                  getColumnDefs={getColumnDefs_rockfall}
                  newRowTemplate={newRowTemplate_rockfall}
                  eyeIconCallback={eyeIconCallback_rockfall}
                  onRowSelect={onRowSelect}
                  openMapForCoords={openMapForCoords}
                  closeMapForCoords={closeMapForCoords}
                  selectedCoords={selectedCoords}
                  columnKey={'name'}
                  showTransactionModal={true}

                />


              </div>


        </div>

      </div>
    </div>
  );
};

export default MainPage;
